import type { IUserRepository } from './interfaces/IUserRepository'
import type { StudentUser } from '@/types'
import { getDocument } from '@/services/firestore'

export class FirestoreUserRepository implements IUserRepository {
  async getById(id: string): Promise<StudentUser | null> {
    return getDocument<StudentUser>('users', id)
  }

  async getByIds(ids: string[]): Promise<StudentUser[]> {
    const results: StudentUser[] = []
    const uniqueIds = [...new Set(ids)]
    const promises = uniqueIds.map((id) => this.getById(id))
    const docs = await Promise.all(promises)
    for (const doc of docs) {
      if (doc) results.push(doc)
    }
    return results
  }
}
